import * as yup from "yup";
export const runmachanismSchema = yup.object().shape({
  TankA: yup.string(),
  tankAPStartDate: yup.string().required("Required"),
  tankAPEndDate:  yup.string().required("Required"),
  tankAStartDate: yup.string().required("Required"),
  tankAStartTime: yup.string().required("Required"),
  tankAEndDate: yup.string().required("Required"),
  tankAEndTime: yup.string().required("Required"),
  tankAOnTime: yup.string().required("Required"),
  tankAOffTime: yup.string().required("Required"),
  tankAOnDuration: yup.string().required("Required"),
  tankAOffDuration: yup.string().required("Required"),

  TankB: yup.string(),
  tankBPStartDate: yup.string().required("Required"),
  tankBPEndDate: yup.string().required("Required"),
  tankBStartDate: yup.string().required("Required"),
  tankBStartTime: yup.string().required("Required"),
  tankBEndDate: yup.string().required("Required"),
  tankBEndTime: yup.string().required("Required"),
  tankBOnTime: yup.string().required("Required"),
  tankBOffTime: yup.string().required("Required"),
  tankBOnDuration: yup.string().required("Required"),
  tankBOffDuration: yup.string().required("Required"),

  TankC: yup.string(),
  phDownPStartDate: yup.string().required("Required"),
  phDownPEndDate: yup.string().required("Required"),
  tankCStartDate: yup.string().required("Required"),
  tankCStartTime: yup.string().required("Required"),
  tankCEndDate: yup.string().required("Required"),
  tankCEndTime: yup.string().required("Required"),
  tankCOnTime: yup.string().required("Required"),
  tankCOffTime: yup.string().required("Required"),
  tankCOnDuration: yup.string().required("Required"),
  tankCOffDuration: yup.string().required("Required"),
});
